import { apiFetch } from "./client";

/** Zašto provere nema, kad je nema. */
export type CreditCheckUnavailable =
  | "NOT_CONFIGURED"
  | "FOREIGN"
  | "NO_TAX_NUMBER"
  | "NOT_FOUND"
  | "FAILED";

export type CreditAlarm = {
  code: "companyStatus" | "accountBlocked" | "disputes" | "executions" | "lowScore" | "blockageHistory";
  severity: "CRITICAL" | "WARNING";
  value: string | null;
};

/** Jedan aktivan spor; broj bez predmeta ne govori šta da se radi. */
export type CreditDispute = {
  caseNumber: string | null;
  courtName: string | null;
  basis: string | null;
  /** TUZENI nosi rizik, TUZILAC ne. */
  role: string | null;
  amount: number | null;
  currency: string | null;
  receivedOn: string | null;
  status: string | null;
};

export type CreditCheck = {
  available: boolean;
  reason: CreditCheckUnavailable | null;
  errorMessage: string | null;
  /** Kad je snimak uzet iz registra; ekran po tome kaže koliko je podatak star. */
  fetchedAt: string | null;

  companyStatus: string | null;
  accountStatus: string | null;
  blockageDays: number | null;
  blockageCountEver: number | null;
  blockageDaysTotal: number | null;

  creditScore: number | null;
  /** 1 rastuće, 0 isto, 2 opadajuće — kako ih registar daje. */
  creditScoreTrend: number | null;
  /** Prosek delatnosti i mesto firme u njoj; broj 88 bez toga nema meru. */
  industryAvgScore: number | null;
  industryRank: number | null;
  industryTotal: number | null;
  industryName: string | null;

  disputesDefendantActive: number | null;
  disputesDefendantAmount: number | null;
  disputesPlaintiffActive: number | null;
  disputesPlaintiffAmount: number | null;
  executionsDebtor: number | null;
  pledgesDebtor: number | null;

  reportYear: number | null;
  revenues: number | null;
  netResult: number | null;
  assets: number | null;
  capital: number | null;
  employees: number | null;
  financeCurrency: string | null;

  alarms: CreditAlarm[];
  disputes: CreditDispute[];
};

export const creditCheckApi = {
  get: (companyId: string) => apiFetch<CreditCheck>(`/companies/${companyId}/credit-check`),
  refresh: (companyId: string) =>
    apiFetch<CreditCheck>(`/companies/${companyId}/credit-check/refresh`, { method: "POST" }),
};
